import React, { useState, useEffect } from "react";
import { useThemeStore } from "../../store/theme";
import { useAppStore } from "../../store";

import { getCategories } from "../../services/ideas.service";
import { Category } from "../../types";

const RightSidebar: React.FC = () => {
  const { colors, theme } = useThemeStore();
  const { currentCategory, setCurrentCategory } = useAppStore();
  const [filters, setFilters] = useState<Category[]>([]);

  useEffect(() => {
    getCategories().then(setFilters).catch(console.error);
  }, []);

  return (
    <aside
      className="w-50 border-l pt-4 pb-6 px-6 fixed right-0 top-16 h-full overflow-y-auto"
      style={{
        backgroundColor: colors.background,
        borderColor: theme === "light" ? "#e5e7eb" : "#374151",
      }}
    >
      <div className="mb-8 flex flex-col items-end">
        <h3
          className="text-sm font-medium mb-3 text-right"
          style={{ color: colors.gray }}
        >
          Filter by
        </h3>
        <div className="flex flex-col items-end space-y-2 w-full">
          {filters.map((filter) => (
            <button
              key={filter.key}
              onClick={() => setCurrentCategory(filter.key)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${
                currentCategory === filter.key
                  ? "bg-emerald-500 text-white"
                  : "bg-transparent hover:bg-gray-100 dark:hover:bg-gray-800"
              }`}
              style={{
                border: `1px solid ${currentCategory === filter.key ? "transparent" : theme === "light" ? "#e5e7eb" : "#374151"}`,
                color: currentCategory === filter.key ? "white" : colors.text,
              }}
            >
              {filter.name}
            </button>
          ))}
        </div>
      </div>

    </aside>
  );
};

export default RightSidebar;
